import { render } from "./pf_ai.vue?vue&type=template&id=c8f7356e"
import script from "./pf_ai.vue?vue&type=script&lang=js"
export * from "./pf_ai.vue?vue&type=script&lang=js"

import "./pf_ai.vue?vue&type=style&index=0&id=c8f7356e&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__